/* eslint-disable array-callback-return */
import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Paper,
  Typography,
  Tooltip,
} from "@mui/material";
import { CSSProperties } from "react";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ValidationError from "../validation-error-label";
import Color from "../../theme/color";
import Switch from "@mui/material/Switch";
import { alpha, styled } from "@mui/material/styles";
import { pink } from "@mui/material/colors";
import useMediaQuery from "@mui/material/useMediaQuery";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { IMaskInput } from "react-imask";
interface CustomProps {
  onChange: (event: { target: { name: string; value: number } }) => void;
  name: string;
}

const TextMaskCustom = React.forwardRef<HTMLInputElement, CustomProps>(
  function TextMaskCustom(props, ref) {
    const { onChange, name, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="$num"
        unmask={true}
        blocks={{
          num: {
            mask: Number,
            thousandsSeparator: ",",
            radix: ".",
            scale: 2,
          },
        }}
        inputRef={ref}
        onAccept={(value: any) => onChange({ target: { name: name, value } })}
        overwrite
      />
    );
  }
);

const SwitchColor = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "",
    "&:hover": {
      backgroundColor: alpha(pink[600], theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#808080",
  },
}));

const GridCustom = styled(Grid)({
  div: {
    " .MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-1 css-1xpt0qw-MuiGrid-root":
      -0,
  },
});

const label = { inputProps: { "aria-label": "Color switch demo" } };

const TicketTable = ({
  ticketTypeData,
  validationError,
  data,
  handleAddFields,
  handleRemoveFields,
  handleChangeInput,
  isSoldOut,
}: TicketTableProps) => {
  const [check] = useState(false);
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));

  const showAddButton = (index: number) => {
    if (data.length === 1) {
      return true;
    }
    if (data.length - 1 === index) {
      return true;
    }
    return false;
  };
  const showRemoveButton = (index: number) => {
    if (data.length === 1) {
      return false;
    }
    if (data.length - 1 === index) {
      return false;
    }
    return true;
  };
  const handleSwitchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const newCheck = event.target.checked;
    const updatedData = [...data];
    updatedData[index].IsSoldOut = newCheck;
    isSoldOut(newCheck);
    handleChangeInput(index, event, "IsSoldOut", newCheck ? "true" : "false");
  };
  const renderAddRemoveIngredient = (index: number) => {
    return (
      <div>
        {showAddButton(index) ? (
          <>
            <Button
              onClick={() => handleAddFields()}
              color="primary"
              variant="contained"
              style={{ backgroundColor: Color.green, margin: "3px" }}
            >
              <AddIcon />
            </Button>
          </>
        ) : null}
        {showRemoveButton(index) ? (
          <Button
            onClick={() => handleRemoveFields(index)}
            color="primary"
            variant="contained"
            style={{ backgroundColor: Color.red, margin: "3px" }}
          >
            <DeleteForeverIcon />
          </Button>
        ) : (
          <>
            {showRemoveButton(index) === showRemoveButton(0) ? null : (
              <Button
                onClick={() => handleRemoveFields(index)}
                color="primary"
                variant="contained"
                style={{ backgroundColor: Color.red, margin: "3px" }}
              >
                <DeleteForeverIcon />
              </Button>
            )}
          </>
        )}
      </div>
    );
  };

  function addTimeToCurrentDate(timeString: string): Date | null {
    const [hours, minutes, seconds] = timeString.split(":").map((part) => {
      const parsedPart = parseInt(part, 10);
      return isNaN(parsedPart) ? 0 : parsedPart;
    });

    const currentDate = new Date();
    currentDate.setHours(hours);
    currentDate.setMinutes(minutes);
    currentDate.setSeconds(seconds);

    return isNaN(currentDate.getTime()) ? null : currentDate;
  }

  return (
    <div>
      <Box
        sx={{
          width: "100%",
        }}
      >
        {data.map((inputField: any, index: number) => {
          if (inputField?.IsDisabled === true) return;
          return (
            <Paper
              key={index}
              elevation={6}
              style={{
                padding: "18px",
                width: "100%",
                marginTop: 40,
              }}
            >
              <Grid
                sx={{
                  width: "100%",
                  justifyContent: "space-between",
                  flexDirection: "row",
                }}
                container
                spacing={1}
                columns={{ xs: 12, sm: 12, md: 12 }}
              >
                <GridCustom
                  sx={{
                    width: isMobile ? "80%" : "90%",

                    marginBlock: 1,
                    marginBottom: data.length - 1 === index ? 0 : 2,
                  }}
                  container
                  spacing={1}
                  columns={{ xs: 11, sm: 11, md: 11 }}
                  key={index}
                >
                  <Grid
                    item
                    xs={11}
                    sm={4}
                    md={2.75}
                    style={{ marginBlock: 5 }}
                  >
                    <TextField
                      size="small"
                      type="text"
                      placeholder="Ticket Type "
                      fullWidth
                      label="Ticket Type *"
                      name="TicketType"
                      value={inputField?.TicketType}
                      onChange={async (event: any) =>
                        await handleChangeInput(index, event, "", "TicketType")
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <ValidationError
                      formErrors={validationError[`TicketType-${index}`]}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={11}
                    sm={4}
                    md={8.25}
                    style={{ marginBlock: 5 }}
                  >
                    <TextField
                      size="small"
                      type="text"
                      placeholder="Short Desc"
                      fullWidth
                      label="Short Desc"
                      name="ShortDesc"
                      value={inputField?.ShortDesc}
                      onChange={async (event: any) =>
                        await handleChangeInput(index, event, "", "ShortDesc")
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={11}
                    sm={4}
                    md={2.75}
                    style={{ marginBlock: 5 }}
                  >
                    <TextField
                      size="small"
                      placeholder="$000"
                      label="Ticket Price *"
                      fullWidth
                      variant="outlined"
                      value={inputField.Price?.toString()}
                      onChange={(event: any) =>
                        handleChangeInput(index, event, "", "Price")
                      }
                      id="formatted-text-mask-input"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputComponent: TextMaskCustom as any,
                      }}
                    />

                    <ValidationError
                      formErrors={validationError[`Price-${index}`]}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={11}
                    sm={4}
                    md={2.75}
                    style={{ marginBlock: 5 }}
                  >
                    <TextField
                      size="small"
                      type="number"
                      placeholder="00"
                      label="Quantity *"
                      fullWidth
                      name="QuantityAvailable"
                      value={inputField?.QuantityAvailable}
                      onChange={(event: any) =>
                        handleChangeInput(index, event, "", "QuantityAvailable")
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <ValidationError
                      formErrors={validationError[`QuantityAvailable-${index}`]}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={11}
                    sm={4}
                    md={2.75}
                    style={{ marginBlock: 5 }}
                  >
                    <TextField
                      size="small"
                      type="number"
                      placeholder="00"
                      fullWidth
                      label="Per Order Limit"
                      name="PerOrderLimit"
                      value={inputField.PerOrderLimit}
                      onChange={(event: any) =>
                        handleChangeInput(index, event, "", "PerOrderLimit")
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <ValidationError
                      formErrors={validationError[`PerOrderLimit-${index}`]}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={11}
                    sm={4}
                    md={2.75}
                    style={{ marginBlock: 5 }}
                  >
                   <Tooltip title="Order in which you want to display different ticket" placement="top-start"> 
                      <TextField
                        size="small"
                        type="number"
                        placeholder="00"
                        label="Ordering"
                        fullWidth
                        name="Ordering"
                        value={inputField?.Ordering}
                        onChange={(event: any) =>
                          handleChangeInput(index, event, "", "Ordering")
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Tooltip>
                    <ValidationError
                      formErrors={validationError[`Ordering-${index}`]}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={11}
                    sm={4}
                    md={2.75}
                    style={{ marginBlock: 5 }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        slotProps={{
                          textField: {
                            size: "small",
                            name: "SaleStartDateTime",
                            error: false,
                            fullWidth: true,
                          },
                        }}
                        disablePast
                        format="ll"
                        label="Sale Start Date"
                        value={dayjs(inputField.SaleStartDateTime)}
                        onChange={(event: any) =>
                          handleChangeInput(
                            index,
                            event,
                            "",
                            "SaleStartDateTime"
                          )
                        }
                      />
                    </LocalizationProvider>
                    <ValidationError
                      formErrors={validationError[`SaleStartDateTime-${index}`]}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={11}
                    sm={4}
                    md={2.75}
                    style={{ marginBlock: 5 }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        slotProps={{
                          textField: {
                            size: "small",
                            name: "SaleStartTime",
                            error: false,
                            fullWidth: true,
                          },
                        }}
                        timezone="default"
                        value={dayjs(
                          addTimeToCurrentDate(inputField.SaleStartTime)
                        )}
                        label="Sale Start Time"
                        onChange={(event) =>
                          handleChangeInput(index, event, "", "SaleStartTime")
                        }
                      />
                    </LocalizationProvider>
                    <ValidationError
                      formErrors={validationError[`SaleStartTime-${index}`]}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={11}
                    sm={4}
                    md={2.75}
                    style={{ marginBlock: 5 }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        slotProps={{
                          textField: {
                            size: "small",
                            name: "SaleEndDate",
                            error: false,
                            fullWidth: true,
                          },
                        }}
                        disablePast
                        format="ll"
                        label="Sale End Date"
                        value={dayjs(inputField.SaleEndDateTime)}
                        onChange={(event: any) =>
                          handleChangeInput(index, event, "", "SaleEndDateTime")
                        }
                      />
                    </LocalizationProvider>
                    <ValidationError
                      formErrors={validationError[`SaleEndDateTime-${index}`]}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={11}
                    sm={4}
                    md={2.75}
                    style={{ marginBlock: 5 }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        slotProps={{
                          textField: {
                            size: "small",
                            name: "SaleEndTime",
                            error: false,
                            fullWidth: true,
                          },
                        }}
                        timezone="default"
                        value={dayjs(
                          addTimeToCurrentDate(inputField.SaleEndTime)
                        )}
                        label="Sale End Time"
                        onChange={(event) =>
                          handleChangeInput(index, event, "", "SaleEndTime")
                        }
                      />
                    </LocalizationProvider>
                    <ValidationError
                      formErrors={validationError[`SaleEndTime-${index}`]}
                    />
                  </Grid>
                </GridCustom>
                <Grid
                  sx={{
                    width: isMobile ? "20%" : "10%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                    }}
                  >
                    <Typography style={{ fontSize: "13px" }}>
                      Mark as Sold Out
                    </Typography>

                    <SwitchColor
                      onChange={(event: any) =>
                        handleSwitchChange(event, index)
                      }
                      {...label}
                      value={inputField?.IsSoldOut}
                      checked={inputField?.IsSoldOut}
                      defaultChecked={false}
                      color="error"
                      style={{ marginBottom: 2 }}
                    />

                    {renderAddRemoveIngredient(index)}
                  </div>
                </Grid>
              </Grid>
              {/* {data?.length > 1 && data.length - 1 !== index ? (
                <Divider sx={{ marginBottom: 1.5 }} />
              ) : null} */}
            </Paper>
          );
        })}
      </Box>
    </div>
  );
};

export default TicketTable;

interface TicketTableProps {
  style?: CSSProperties | undefined;
  ticketTypeData?: any;
  validationError: any;
  handleChangeInput: (
    index: number,
    event: any,
    ticketTypeId?: string,
    name?: string
  ) => void;
  handleAddFields: () => void;
  isSoldOut: (newValue: any) => void;
  handleRemoveFields: (index: number) => void;
  data: any;
}
